<template>
  <div class="auth">
    <h3>Регистрация</h3>
    <div v-if="errors.length">
      <div v-for="(error, key) in errors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div class="auth__form">
      <div v-if="isClient">
        <div class="auth__formDiv">
          <label>Номер телефона</label>
          <input
            v-model="registerData.phone"
            tabindex="2"
            type="text"
            name="phone"
            placeholder="+7 (___) ___-__-__"
            v-mask="{
            mask: '+7 (F##) ###-##-##',
            tokens: {
              F: {
                pattern: /(?!8)\d/,
              },
              '#': { pattern: /\d/ },
            },
          }"
            class="auth__inputDate"
          />
        </div>
      </div>
      <div v-if="!isClient">
        <div class="auth__formDiv">
          <label>Тип документа</label>
          <select v-model="registerData.docType">
            <option value="1">Паспорт РФ</option>
            <option value="8">Паспорт иностранного гражданина</option>
          </select>
        </div>
        <div class="auth__formDiv">
          <label>Серия и номер паспорта</label>
          <input
            v-if="registerData.docType == '1'"
            type="text"
            v-mask="'####-######'"
            placeholder=""
            class="auth__inputDate"
            v-model="registerData.docNum"
          />
          <input
            v-if="registerData.docType == '8'"
            type="text"
            placeholder=""
            class="auth__inputDate"
            v-model="registerData.docNum"
          />
        </div>
        <div class="auth__formDiv">
          <label>Дата выдачи паспорта</label>
          <input
            type="date"
            class="auth__inputDate"
            v-model="registerData.docDate"
          >
        </div>
      </div>
      <div class="auth__btnBlock">
        <button @click="sendRegisterData" class="auth__submit">Зарегистрироваться</button>
        <button @click="$router.push({name: 'login'})" class="auth__btn-back">Назад</button>
      </div>
      <div class="auth__agreement">
        <p>Нажимая "Зарегистрироваться" я
          <a target="_blank" href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">соглашаюсь</a>
          на обработку моих персональных данных</p>
      </div>
    </div>
  </div>
  <ModalNotIdentify v-if="not_identity"/>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from "axios";
import { url } from "@/profile/composables/url";
import ModalNotIdentify from "@/profile/components/ModalNotIdentify.vue";

export default {
  name: "SigninView",
  components: {ModalNotIdentify},
  data() {
    return {
      errors: [],
      registerData: {
        docType: "1",
        docNum: null,
        docDate: "",
        phone: null,
        send_sms_time: 0,
        contract: null
      },
      cp_id: 0,
      isClient: false,
      not_identity: false,
    };
  },
  methods: {
    sendRegisterData() {
      let tmp, params;
      if (!this.isClient) {
        if (this.registerData.docType == 1) {
          tmp = this.registerData.docNum.split("-");
          params = {
            command: "register_check",
            doc_type: this.registerData.docType,
            doc_serial: tmp[0],
            doc_number: tmp[1],
            doc_date: this.registerData.docDate,
            token: this.$myApp.token.get()
          };
        } else {
          params = {
            command: "register_check",
            doc_type: this.registerData.docType,
            doc_serial: "other",
            doc_number: this.registerData.docNum,
            doc_date: this.registerData.docDate,
            token: this.$myApp.token.get()
          };
        }
      } else {
        tmp = this.registerData.phone.split(" ").join("");
        tmp = tmp.split("-").join("");
        tmp = tmp.split("+").join("");
        tmp = tmp.split("(").join("");
        tmp = tmp.split(")").join("");
        tmp = tmp.substring(1);
        let date_now = (new Date()).getTime();
        if(date_now < this.send_sms_time){
          return;
        }
        this.send_sms_time = date_now + 30000;
        params = {
          command: "register_new",
          phone: tmp,
          contract: this.cp_id,
          token: this.$myApp.token.get(),
          new_phone: true
        };
      }
      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data; // for commit
          if (data.state === "ERR") {
            $this.errors = [];
            if (data.msg_no == "13") {
              // $this.not_identity = true;
              $this.errors.push(
                "К сожалению, по введенным параметрам регистрация недоступна.\n\r"
              );
              $this.errors.push(
                "Вы можете обратиться на горячую линию 8 800 333-90-13 (звонок бесплатный) " +
                "пн-чт с 08:00 до 18:00, пт с 08:00 до 16:45 (время МСК), оставить обращение " +
                "в чат или на эл. почту info@makclife.ru с указанием проблемы, ФИО и номером договора."
              );
            } else {
              $this.errors.push(data.msg_text);
            }
          } else if (data.state === "OK") {
            $this.errors = [];
            $this.errors.push(
              "Введите номер телефона, он необходим для авторизации на сайте"
            );
            if (data.bool == 0) {
              $this.isClient = true;
              $this.cp_id = data.id;
            } else {
              $this.errors = [];
              $this.errors.push(data.msg);
              alert(data.msg);
              setTimeout(() => ($this.$router.push({ name: "login" })), 2000);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  directives: { mask }
};
</script>

<style scoped>
</style>
